<template>
  <button
    :class="['question_btn flex-row', buttonClass, answerStatusClass, {selected: isAnswerSelected}]"
    type=""
    @click.prevent="handleAnswerSelected"
  >
    <span>{{ choice }}</span>

    <p>{{ text }}</p>
  </button>
</template>

<script>
export default {
  name: 'GameAnswerItem',
  emits: ['answer:selected'],
  props: {
    text: {
      type: String,
      default: ''
    },
    choice: {
      type: String,
      default: ''
    },
    validated: {
      type: Boolean,
      default: false
    },
    correct: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: [String, Object, Array],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isAnswerSelected: false
    }
  },
  computed: {
    answerStatusClass () {
      if (!this.validated) { return '' }

      return this.correct ? 'right_answer' : 'wrong_answer'
    }
  },
  methods: {
    handleAnswerSelected () {
      if (this.disabled) { return }

      this.isAnswerSelected = true
      this.$emit('answer:selected', {text: this.text, choice: this.choice})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/game/GameAnswerItem.vue